import React from "react";

export default function SectionHeader({ title }: { title: string }) {
  return (
    <div style={{ textAlign: "center" }}>
      <h2
        style={{
          fontSize: "2.2rem",
          fontWeight: 700,
          color: "#111827",
          margin: 0,
          letterSpacing: "-0.01em",
          lineHeight: 1.1,
          userSelect: "none",
          cursor: "default",
        }}
      >
        {title}
      </h2>
      <div
        style={{
          width: 56,
          height: 4,
          background: "linear-gradient(90deg, #2563EB 60%, #10B981 100%)",
          borderRadius: 2,
          margin: "0.75rem auto 0",
        }}
      />
    </div>
  );
}
